/**
 * Formats a tax ID (CPF or CNPJ) automatically based on length
 * @param {string} value - Tax ID value (can contain formatting)
 * @returns {string} Formatted tax ID
 */
export const formatTaxId = (value) => {
  if (!value) {
    return '';
  }

  const cleanValue = value.replace(/\D/g, '');

  if (cleanValue.length <= 11) {
    return formatCpf(cleanValue);
  }

  return formatCnpj(cleanValue);
};

/**
 * Formats a CPF number with dots and dash
 * @param {string} cleanValue - Clean CPF value (only numbers)
 * @returns {string} Formatted CPF
 */
const formatCpf = (cleanValue) => {
  if (cleanValue.length <= 3) {
    return cleanValue;
  }

  if (cleanValue.length <= 6) {
    return cleanValue.replace(/(\d{3})(\d{0,3})/, '$1.$2');
  }

  if (cleanValue.length <= 9) {
    return cleanValue.replace(/(\d{3})(\d{3})(\d{0,3})/, '$1.$2.$3');
  }

  return cleanValue.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, '$1.$2.$3-$4');
};

/**
 * Formats a CNPJ number with dots, slash and dash
 * @param {string} cleanValue - Clean CNPJ value (only numbers)
 * @returns {string} Formatted CNPJ
 */
const formatCnpj = (cleanValue) => {
  if (cleanValue.length <= 2) {
    return cleanValue;
  }

  if (cleanValue.length <= 5) {
    return cleanValue.replace(/(\d{2})(\d{0,3})/, '$1.$2');
  }

  if (cleanValue.length <= 8) {
    return cleanValue.replace(/(\d{2})(\d{3})(\d{0,3})/, '$1.$2.$3');
  }

  if (cleanValue.length <= 12) {
    return cleanValue.replace(/(\d{2})(\d{3})(\d{3})(\d{0,4})/, '$1.$2.$3/$4');
  }

  return cleanValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/, '$1.$2.$3/$4-$5');
}; 
